import { createFetcher } from "api/helpers"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project, params) => {
    return `${host}/itsm/${project}/get_incident_count?${params}`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined) console.log("No params data supplied.")
  },
  makeResponseData: (json) => {
    if (!json?.OTHER) return json
    const { OTHER, ...accounts } = json
    return { ...accounts, EMPTY: OTHER }
  }
}
export default createFetcher(fetcherConfiguration)
